import React from 'react'
import Link from 'gatsby-link'
import SignUpStatic from '../components/Forms/signUpStatic'
import NextStaticPage from '../components/Linking/nextStaticPage'
import Helmet from "react-helmet"
const PortfolioPage = () => (
   <div style={{ margin: '3rem auto', maxWidth: 960 }}>
     <Helmet>
        <title>Portfolio | @gmugart</title>
    </Helmet>
      
    <article>
   
    <SignUpStatic message="¡Portfolio en camino! Suscribete a la newsletter y serás el primero en enterarte de la publicación. "/>
    </article> 
    <NextStaticPage to="sobre-mi" text="Más sobre gmugart"/>
  </div>
)

export default PortfolioPage



// WEBPACK FOOTER //
// ./src/pages/portfolio.js